// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ApprovalButtons_buttons__118Tp","hasErrorMessage":"ApprovalButtons_hasErrorMessage__31chP","rejectAll":"ApprovalButtons_rejectAll__2L530"};